import { render, staticRenderFns } from "./EuthanasiaReasonDetail.vue?vue&type=template&id=22da1244&scoped=true&"
import script from "./EuthanasiaReasonDetail.vue?vue&type=script&lang=js&"
export * from "./EuthanasiaReasonDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da1244",
  null
  
)

export default component.exports